
import { Navbar, Sidebar, AppMain, DevTools } from '@/views/layout/components';

export default {
  name: 'layout',

  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain,
    DevTools: DevTools
  },

  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }
};